import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { gosafeApi } from "../../api";
import {
  setScheduleEvent,
  updateScheduleEvent,
  clearScheduleEvent,
  updateScheduleEventPatientSurgery,
} from "../../store/doctor/scheduleEventSlice";
import {
  setIsLoading,
  setErrorMessage,
  setSuccessMessage,
} from "../../store/doctor/formEventSlice";
import { deleteScheduleEvent } from "../../store/doctor/dailyAssessmentSlice";
import { updatePatientSurgery } from "../../store/doctor/patientSurgerySlice";
import { translations, sleep } from "../../helpers";

export const useScheduleEventStore = () => {
  const dispatch = useDispatch();

  const { scheduleEvent } = useSelector((state) => state.doctor.scheduleEvent);

  const handleSetScheduleEvent = useCallback(
    (scheduleEvent) => {
      dispatch(setScheduleEvent(scheduleEvent));
    },
    [dispatch]
  );

  const handleUpdateScheduleEvent = useCallback(
    (partialEvent) => {
      dispatch(updateScheduleEvent(partialEvent));
    },
    [dispatch]
  );

  const handleClearScheduleEvent = useCallback(
    (scheduleEvent) => {
      dispatch(deleteScheduleEvent(scheduleEvent));
      dispatch(clearScheduleEvent());
    },
    [dispatch]
  );

  const startPatientSurgeryAssessment = useCallback(
    async (body) => {
      try {
        dispatch(setIsLoading());

        const { patientSurgeryId, id: scheduleEventId } = scheduleEvent;

        const { protocolId, ...newBody } = {
          ...body,
          numberEvents: Number(body.numberEvents),
          clearanceNote: body.clearanceNote || null,
          scheduleEventId,
        };

        // const data = {
        //   message: "bien",
        //   patientSurgery: {
        //     id: patientSurgeryId,
        //     numberEvents: newBody.numberEvents,
        //     protocol: newBody.protocol,
        //     state: "ASSESSMENT_MADE",
        //     clearanceStatus: newBody.clearanceStatus,
        //     clearanceNote: newBody.clearanceNote,
        //   },
        //   scheduleEvent: {
        //     id: scheduleEventId,
        //     attended: true,
        //   },
        // };

        const { data } = await gosafeApi.put(
          `patientSurgery/byAssessmentMade/${patientSurgeryId}`,
          newBody
        );

        dispatch(updateScheduleEventPatientSurgery(data));
        dispatch(updatePatientSurgery(data));
        dispatch(setSuccessMessage(translations[data.message] || data.message));
        return;
      } catch (error) {
        dispatch(
          setErrorMessage(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
      }
    },
    [dispatch, scheduleEvent]
  );

  const startPatientSurgeryFeedback = useCallback(
    async (body) => {
      try {
        dispatch(setIsLoading());

        const { patientSurgeryId } = scheduleEvent;

        // console.log("body", body);

        const { data } = await gosafeApi.post(
          `patientSurgery/feedback/${patientSurgeryId}`,
          body
        );

        dispatch(
          setSuccessMessage(
            "¡Listo! Calificaste nuestra clasificación. Gracias por tu opinión."
          )
        );
        return;
      } catch (error) {
        dispatch(
          setErrorMessage(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
        return;
      }
    },
    [dispatch, scheduleEvent]
  );

  const startPatientSurgeryAssessmentNoShow = useCallback(async () => {
    try {
      dispatch(setIsLoading());

      const { patientSurgeryId, id: scheduleEventId } = scheduleEvent;

      const body = {
        scheduleEventId,
        attended: false,
      };

      // console.log("patientSurgeryId", patientSurgeryId);
      // console.log("body", body);
      // await sleep(2000);

      // const data = {
      //   message: "patientSurgery update successfully",
      //   patientSurgery: {
      //     id: patientSurgeryId,
      //     state: "ASSESSMENT_NO_SHOW",
      //   },
      //   scheduleEvent: {
      //     id: scheduleEventId,
      //     attended: false,
      //   },
      // };

      const { data } = await gosafeApi.put(
        `patientSurgery/byNoPresentAssessment/${patientSurgeryId}`,
        body
      );

      dispatch(updateScheduleEventPatientSurgery(data));
      dispatch(updatePatientSurgery(data));
      dispatch(setSuccessMessage(translations[data.message] || data.message));
      return;
    } catch (error) {
      dispatch(
        setErrorMessage(
          translations[error?.response?.data?.message] ||
            error?.response?.data?.message ||
            error?.message
        )
      );
    }
  }, [dispatch, scheduleEvent]);

  const startPatientSurgeryFinalAssessment = useCallback(
    async (formState) => {
      try {
        dispatch(setIsLoading());

        const { patientSurgeryId, id: scheduleEventId } = scheduleEvent;

        const body = {
          scheduleEventId,
          ...formState,
        };

        const { data } = await gosafeApi.put(
          `patientSurgery/presentFinalAssessment/${patientSurgeryId}`,
          body
        );

        dispatch(updateScheduleEventPatientSurgery(data));
        dispatch(updatePatientSurgery(data));
        dispatch(setSuccessMessage(translations[data.message] || data.message));
        return;
      } catch (error) {
        dispatch(
          setErrorMessage(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
      }
    },
    [dispatch, scheduleEvent]
  );

  return {
    // Props
    scheduleEvent,

    // Methods
    handleSetScheduleEvent,
    handleClearScheduleEvent,
    startPatientSurgeryAssessment,
    startPatientSurgeryFeedback,
    startPatientSurgeryAssessmentNoShow,
    startPatientSurgeryFinalAssessment,
  };
};
